import React from 'react';
import { FlagSvg } from './flag-svg';

const FLAG_SIZE = 18;

export const FlagNote = () => {
    return <div className="flag">
        <span className="flg-title"> *Ghi chú: </span>
        <div className="flag-wapper">
            <div className="flag-note">
                <FlagSvg color={'#ec3c39'} width={FLAG_SIZE} height={FLAG_SIZE} />: ODO không nhận dạng được ảnh
        </div>
            <div className="flag-note">
                <FlagSvg color={'#e9e23a'} width={FLAG_SIZE} height={FLAG_SIZE} />: NKHT trong nhiều ngày
        </div>
            <div className="flag-note">
                <FlagSvg color={'#ab24d4'} width={FLAG_SIZE} height={FLAG_SIZE} />: NKHT có xe trong trạng thái không thể điều động
        </div>
            <div className="flag-note">
                <FlagSvg color={'#00a3f7'} width={FLAG_SIZE} height={FLAG_SIZE} />: NKHT đổi xe
        </div>
            <div className="flag-note">
                <FlagSvg color={'#008726'} width={FLAG_SIZE} height={FLAG_SIZE} />: NKHT thay đổi định mức giữa tháng
        </div>
            <div className="flag-note">
                <FlagSvg color={'#ec7c25'} width={FLAG_SIZE} height={FLAG_SIZE} />: NKHT thay đổi ngày làm việc giữa tháng
        </div>
            <div className="flag-note">
                <FlagSvg color={'#e61592'} width={FLAG_SIZE} height={FLAG_SIZE} />: NKHT thêm bằng tay
        </div>
            <div className="flag-note">
                <img style={{ marginRight: 3 }} src={require('../../../../assets/icons/un-fixed.svg')} width={FLAG_SIZE} height={FLAG_SIZE} />: Admin hoàn thành chỉnh sửa
        </div>
            <div className="flag-note">
                <img style={{ marginRight: 3 }} src={require('../../../../assets/icons/fixed.svg')} width={FLAG_SIZE} height={FLAG_SIZE} />: Cảnh báo chỉnh sửa
        </div>
        </div>
    </div>
}